import { gridConfig } from '../../fuse-responsive-grid/src/grid';

export const columnGapRange = {
	xxs: Array.from(Array(5).keys()).splice(1), // 1-4
	m: Array.from(Array(8).keys()).splice(1), // 1-7
	l: Array.from(Array(10).keys()).splice(1), // 1-9
	xl: Array.from(Array(12).keys()).splice(1), // 1-11
}

export const defaultColumnGaps = {
	xxs: gridConfig.xxs.gutter,
	m: gridConfig.m.gutter,
	l: gridConfig.l.gutter,
	xl: gridConfig.xl.gutter,
};

const validColumnGapSizes = ['xxs', 'm', 'l', 'xl'];

export const isColumnGapSizeValid = (gapSizeSpacingNumber, breakpoint) => {
	const maxSize = Math.max(...columnGapRange[breakpoint]);
	const isGapValid = gapSizeSpacingNumber > 0 && gapSizeSpacingNumber <= maxSize;
	const isBreakpointValid = validColumnGapSizes.includes(breakpoint);

	return isGapValid && isBreakpointValid;
}